if (!customElements.get('copy-link')) {
  class FiltersDrawer extends DropdownDisclosure {
    constructor() {
      super();

      this.breakpoint = window.matchMedia(`(min-width: ${this.getAttribute('data-breakpoint')}px)`);
      this.isMobile = false;
    }

    breakpointChecker() {
      this.isMobile = (e) => {
        if (this.breakpoint.matches === true) {
          this.isMobile = false;
        } else {
          this.isMobile = true;
        }
      }

      this.breakpoint.addEventListener('change', this.isMobile);
      this.isMobile();
    }

    open(summaryElement, detailsElement) {
      setTimeout(() => {
        detailsElement.classList.add('is-open');
      });
      summaryElement.setAttribute('aria-expanded', true);
      trapFocus(detailsElement, summaryElement);
      this.breakpointChecker();
      if (!this.isMobile) return;
      bodyScroll.lock(
        this.querySelector('[data-scroll-container]') ||
          summaryElement.nextElementSibling,
      );
    }

    close(event, summaryElement, detailsElement) {
      if (event === undefined) return;
      event.preventDefault();

      detailsElement.classList.remove('is-open');
      removeTrapFocus(summaryElement);
      this.closeAnimation(detailsElement);
      this.breakpointChecker();
      if (!this.isMobile) return;
      bodyScroll.unlock(
        this.querySelector('[data-scroll-container]') ||
          this.detailsElement.querySelector('summary').nextElementSibling,
      );
    }
  }

  customElements.define('filters-drawer', FiltersDrawer);
}
